var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: 22,
    viewBox: "0 0 17 22",
    fill: "#36c",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0h13a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm6.545 4.026a5.594 5.594 0 0 0-5.588 5.587 5.594 5.594 0 0 0 5.588 5.588 5.594 5.594 0 0 0 5.587-5.588 5.594 5.594 0 0 0-5.587-5.587zM12.6 8.88h-1.59c-.091-1.293-.417-2.291-.78-3.028A4.135 4.135 0 0 1 12.6 8.88zm-8.11 1.466h1.59c.091 1.292.417 2.29.78 3.028a4.135 4.135 0 0 1-2.37-3.028zm1.59-1.465H4.49a4.135 4.135 0 0 1 2.37-3.028c-.363.737-.689 1.735-.78 3.028zm2.466 4.487c-.38-.538-.872-1.51-.997-3.022h1.994c-.125 1.513-.618 2.484-.997 3.022zm-.997-4.487c.125-1.513.617-2.484.997-3.023.38.539.872 1.51.997 3.023H7.548h.001zm2.683 4.493c.363-.737.689-1.736.78-3.028h1.59a4.135 4.135 0 0 1-2.37 3.028zM3.69 16.668v1.465h9.71v-1.465H3.69z",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.adfb7d93.svg";
export { ForwardRef as ReactComponent };